/**
 * OV Shipping Protection - cart behaviour (SOW §6, Tests 7-10).
 *
 * Renders nothing itself: snippets/ov-shipping-protection.liquid computes the
 * fee and paints the two checkout paths; this file wires the clicks.
 *
 *  - [data-ov-sp-protect]  "Checkout with Shipping Protection — $X.XX":
 *        dedupe (never a second protection line), add the protection variant
 *        (qty 1, attribution properties), record the choice as a cart
 *        attribute, then submit the cart form through the real
 *        name="checkout" submitter so Shopify's checkout entry (and Shop Pay)
 *        behaves exactly like the stock button.
 *  - [data-ov-sp-plain]    "Checkout" text link: record the decline, submit.
 *  - [data-ov-sp-remove]   Remove the protection line, refresh the cart.
 *  - [data-ov-sp-learn]    Open the policy modal (<dialog> rendered by the snippet).
 *  - Guard on every render: if the protection line exists with quantity > 1
 *    force it back to 1; if it exists but nothing eligible remains (e.g. the
 *    customer removed the merchandise) remove it.
 *
 * The Cart Transform function re-prices the line server-side from the real
 * shipping address at checkout; the fee shown here is the cart estimate.
 */
(function () {
  if (window.ovShippingProtectionInit) return;
  window.ovShippingProtectionInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function root() { return document.getElementById('ov-shipping-protection'); }

  function cfg() {
    var el = root();
    if (!el) return null;
    return {
      enabled: el.dataset.enabled === 'true',
      variantId: parseInt(el.dataset.variantId, 10),
      productId: parseInt(el.dataset.productId, 10),
      inCart: el.dataset.inCart === 'true',
      lineKey: el.dataset.lineKey || '',
      eligibleCents: parseInt(el.dataset.eligibleCents || '0', 10),
      feeCents: parseInt(el.dataset.feeCents || '0', 10),
      rate: el.dataset.rate,
      zone: el.dataset.zone,
      currency: el.dataset.currency,
      formId: el.dataset.formId
    };
  }

  async function getCart() {
    var r = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('cart.js ' + r.status);
    return r.json();
  }

  async function post(path, body) {
    var r = await fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    if (!r.ok) {
      var err = await r.json().catch(function () { return {}; });
      throw new Error(err.description || err.message || (path + ' ' + r.status));
    }
    return r.json();
  }

  function protectionLines(cart, c) {
    return (cart.items || []).filter(function (i) {
      return i.product_id === c.productId || i.variant_id === c.variantId;
    });
  }

  // Exactly one protection line at quantity 1 - or none. Returns the surviving line (or null).
  async function normalize(c, cart) {
    var lines = protectionLines(cart, c);
    if (!lines.length) return null;
    var keep = lines[0];
    for (var i = 1; i < lines.length; i++) {
      await post('cart/change.js', { id: lines[i].key, quantity: 0 });
    }
    if (keep.quantity !== 1) {
      await post('cart/change.js', { id: keep.key, quantity: 1 });
    }
    return keep;
  }

  function submitCheckout(c) {
    var form = document.getElementById(c.formId) || document.querySelector('form[action$="/cart"]');
    if (!form) { window.location.href = ROOT + 'checkout'; return; }
    // Quantities are already synced through the Ajax API on every change, and
    // Shopify inserts newly added lines at the TOP of the cart - so the
    // positional updates[] inputs rendered before our add would shift onto
    // the wrong lines. Don't post them; disabled inputs are not submitted.
    form.querySelectorAll('[name="updates[]"]').forEach(function (i) { i.disabled = true; });
    var submitter = form.querySelector('[data-ov-sp-submitter]') ||
      document.querySelector('[data-ov-sp-submitter][form="' + c.formId + '"]') ||
      document.querySelector('[data-ov-sp-plain-submit][form="' + c.formId + '"]') ||
      form.querySelector('button[name="checkout"]');
    if (submitter && typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitter);
    } else if (submitter) {
      submitter.click();
    } else {
      form.submit();
    }
  }

  async function refreshCart() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.refresh === 'function') {
      await drawer.refresh(true);
      return;
    }
    var ci = document.getElementById('cart-items');
    var sectionId = ci && ci.dataset.section;
    if (!sectionId) { window.location.reload(); return; }
    var res = await fetch(window.location.pathname + '?sections=' + sectionId + ',cart-icon-bubble');
    var sections = await res.json();
    [
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-items', section: sectionId, selector: 'cart-items' },
      { id: 'free-shipping-notice', section: sectionId, selector: '.free-shipping-notice' },
      { id: 'ov-cart-messages', section: sectionId, selector: '#ov-cart-messages' },
      { id: 'ov-cart-extras', section: sectionId, selector: '#ov-cart-extras' },
      { id: 'cart-summary', section: sectionId, selector: '.cart__summary' }
    ].forEach(function (t) {
      var html = sections[t.section];
      if (!html) return;
      var sectionEl = document.getElementById(t.id);
      if (!sectionEl) return;
      var tmpl = document.createElement('template');
      tmpl.innerHTML = html;
      var src = tmpl.content.querySelector(t.selector);
      var dst = sectionEl.querySelector(t.selector) || sectionEl;
      dst.innerHTML = src ? src.innerHTML : '';
    });
  }

  function setBusy(btn, on, label) {
    busy = on;
    if (!btn) return;
    btn.disabled = on;
    if (on) { btn.dataset.orig = btn.textContent; btn.textContent = label || 'One moment…'; }
    else if (btn.dataset.orig) { btn.textContent = btn.dataset.orig; }
  }

  async function chooseProtected(btn) {
    var c = cfg();
    if (!c || !c.enabled || busy) return;
    setBusy(btn, true, 'Adding protection…');
    try {
      var cart = await getCart();
      var existing = await normalize(c, cart);
      if (!existing) {
        await post('cart/add.js', {
          items: [{
            id: c.variantId,
            quantity: 1,
            properties: {
              _ov_protection: 'cart',
              _ov_rate: String(c.rate),
              _ov_eligible_value: (c.eligibleCents / 100).toFixed(2),
              _ov_zone: c.zone,
              _ov_currency: c.currency
            }
          }]
        });
      }
      await post('cart/update.js', { attributes: { _ov_protection_choice: 'protected' } });
      submitCheckout(c);
      // If navigation is blocked (e.g. a cart-terms prompt), release the UI.
      setTimeout(function () { setBusy(btn, false); }, 4000);
    } catch (e) {
      console.log('[ov-shipping-protection]', e); // eslint-disable-line
      setBusy(btn, false);
      btn.textContent = 'Try again';
      setTimeout(function () { if (btn.dataset.orig) btn.textContent = btn.dataset.orig; }, 2500);
    }
  }

  async function choosePlain(btn) {
    var c = cfg();
    if (!c || busy) return;
    setBusy(btn, true, 'Continuing…');
    try {
      var cart = await getCart();
      // A declined checkout must never carry a protection line.
      var lines = protectionLines(cart, c);
      for (var i = 0; i < lines.length; i++) {
        await post('cart/change.js', { id: lines[i].key, quantity: 0 });
      }
      await post('cart/update.js', { attributes: { _ov_protection_choice: 'declined' } });
      submitCheckout(c);
      setTimeout(function () { setBusy(btn, false); }, 4000);
    } catch (e) {
      console.log('[ov-shipping-protection]', e); // eslint-disable-line
      setBusy(btn, false);
    }
  }

  async function removeProtection(btn) {
    var c = cfg();
    if (!c || busy) return;
    setBusy(btn, true, 'Removing…');
    try {
      var cart = await getCart();
      var lines = protectionLines(cart, c);
      for (var i = 0; i < lines.length; i++) {
        await post('cart/change.js', { id: lines[i].key, quantity: 0 });
      }
      await post('cart/update.js', { attributes: { _ov_protection_choice: 'removed' } });
      await refreshCart();
    } catch (e) {
      console.log('[ov-shipping-protection]', e); // eslint-disable-line
    } finally {
      busy = false;
    }
  }

  // Render-time guard: keep the protection line sane after quantity edits or
  // merchandise removals made through the regular cart controls.
  var guardTimer = null;
  function guard() {
    clearTimeout(guardTimer);
    guardTimer = setTimeout(async function () {
      var c = cfg();
      if (!c || !c.enabled || !c.inCart || busy) return;
      try {
        var cart = await getCart();
        var lines = protectionLines(cart, c);
        if (!lines.length) return;
        var changed = false;
        if (c.eligibleCents <= 0) {
          for (var i = 0; i < lines.length; i++) { await post('cart/change.js', { id: lines[i].key, quantity: 0 }); }
          changed = true;
        } else if (lines.length > 1 || lines[0].quantity !== 1) {
          await normalize(c, cart);
          changed = true;
        }
        if (changed) await refreshCart();
      } catch (e) { /* best effort */ }
    }, 400);
  }

  // Keep the protected-checkout label on ONE line: shrink the font until the
  // text fits the button (down to 10px), re-run on resize and cart re-renders.
  function fitButtons() {
    document.querySelectorAll('[data-ov-sp-protect]').forEach(function (btn) {
      if (!btn.clientWidth) return; // hidden (drawer closed) - measure when it opens
      btn.style.fontSize = '';
      var size = parseFloat(getComputedStyle(btn).fontSize) || 15;
      var guard = 0;
      while (btn.scrollWidth > btn.clientWidth + 1 && size > 10 && guard < 12) {
        size -= 0.5; btn.style.fontSize = size + 'px'; guard++;
      }
    });
  }
  window.addEventListener('resize', fitButtons);
  var fitMo = new MutationObserver(function () { clearTimeout(fitMo.t); fitMo.t = setTimeout(fitButtons, 50); });

  function openModal(id) {
    var dlg = document.getElementById(id) || document.querySelector('.ov-sp-modal');
    if (!dlg) return;
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); }
    else dlg.setAttribute('open', '');
  }
  function closeModal(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  }

  document.addEventListener('click', function (evt) {
    var learn = evt.target.closest('[data-ov-sp-learn]');
    if (learn) { evt.preventDefault(); evt.stopPropagation(); openModal(learn.getAttribute('data-ov-sp-learn')); return; }
    var close = evt.target.closest('[data-ov-sp-close]');
    if (close) { evt.preventDefault(); closeModal(close.closest('dialog')); return; }
    // Click on the backdrop (the dialog element itself, outside its inner box) closes it.
    if (evt.target.classList && evt.target.classList.contains('ov-sp-modal')) { closeModal(evt.target); return; }
    var protect = evt.target.closest('[data-ov-sp-protect]');
    if (protect) { evt.preventDefault(); chooseProtected(protect); return; }
    var plain = evt.target.closest('[data-ov-sp-plain]');
    if (plain) { evt.preventDefault(); choosePlain(plain); return; }
    var remove = evt.target.closest('[data-ov-sp-remove]');
    if (remove) { evt.preventDefault(); removeProtection(remove); }
  });

  document.addEventListener('on:line-item:change', guard);
  document.addEventListener('on:cart:add', guard);
  var mo = new MutationObserver(guard);
  function arm() {
    fitButtons();
    fitMo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-hidden', 'open'] });
    var drawer = document.getElementById('cart-drawer');
    if (drawer) mo.observe(drawer, { childList: true, subtree: true });
    var summary = document.getElementById('cart-summary');
    if (summary) mo.observe(summary, { childList: true, subtree: true });
    guard();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
}());
